import React from 'react';
import { useQuery } from '@common/hooks';
import { Select, Form } from 'antd';
import { ErrorHandler, LoadingState } from '@common/components';
import { WORKFORCE_GROUP_FLAT_QUERY } from '@scheduling/graphql';

export function WorkforceGroupSelect(props) {
  const { loading, error, data } = useQuery(WORKFORCE_GROUP_FLAT_QUERY);

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="WorkforceGroupSelect"
        messageType="contextual"
      />
    );
  }

  return (
    <Form.Item
      label="Group"
      name="workforceGroupId"
      rules={[
        {
          required: true,
          message: 'Please select a group',
        },
      ]}
    >
      <Select {...props} size="large" placeholder="Select Group">
        {data &&
          data.workforceGroups.map(({ id, name }) => {
            return (
              <Select.Option key={id} value={id}>
                {name}
              </Select.Option>
            );
          })}
      </Select>
    </Form.Item>
  );
}
